import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getAllReportsData } from "src/thunks/reports";
import { Loader } from "src/components/loader";
import { GetError } from "src/constant";
import { Monthly } from "./reportType/monthly";
import _ from "lodash"

export const ReportList = () => {
    /** redux store useDispatch & useSelector ------------------------------ **/
    const dispatch = useDispatch();
    const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
    const { allReportsData, reportsDataLoading } = useSelector((state) => state.reports);
    const { filterAllData } = useSelector((state) => state.goodsin);
    
    /** Variable Declarations ----------------------------------------------------- **/
    const userData = JSON.parse(localStorage.getItem('userDetails'))
    const filterData = filterAllData["report"]
    const orderedClientList = _.orderBy(userData?.projects, ['clientName'], ["asc"])

    /** hooks useEffect----------------------------------------------------- **/
    useEffect(() => {
        getAllReportsDataFunc()
    }, [])

    /** Function to retrieve all reports data ------------------------ **/
    const getAllReportsDataFunc = async () => {
        try {
            await dispatch(getAllReportsData({
                type: "Monthly",
                depotId: filterData?.depotId?.id || 0,
                clientId: filterData?.clientId?.id || 0,
                projectId: filterData?.projectId?.id || 0,
                month: filterData?.month || new Date().getMonth() + 1,
                year: filterData?.year || new Date().getFullYear(),
            }))
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    }

    if (reportsDataLoading) {
        return <Loader />;
    }

    /** If data not found in report shown no data found message ------------------- **/
    if (allReportsData?.length === 0) {
        return <div style={{ display: "flex", width: "100%", justifyContent: "center", height: 500, alignItems: "center" }}>
            No Data found
        </div>
    }
    else
        return (
            <>
                <div className={`summaryReportMain ${isDropdownOpenFlagValue == true ? "add-overlay-for-depot-dropdown" : ""} rh-report`} >
                    <Monthly data={allReportsData} />
                </div>

            </>
        )
};
